import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { PostulacionesSaludService } from 'src/app/services/postulaciones-salud/postulaciones-salud.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { ReembolsosService } from 'src/app/services/reembolsos/reembolsos.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { Tipos } from '../../models/tipos/tipos.model';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import Swal from 'sweetalert2';
import { TextosService } from '../../services/textos/textos.service';
declare const Rut: any;
declare const ageCalculator: any;

@Component({
    selector: 'app-reembolsos',
    templateUrl: '../../pages/reembolsos/reembolsos.component.html',
    styleUrls: ['../../pages/reembolsos/reembolsos.component.css']
})
export class ReembolsosComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    diasDiferencia: any
    diaTerminoConvenio: any
    mesTerminoConvenio: any
    AnnioTerminoConvenio: any
    diaInicioNuevoConvenio: any
    mesInicioNuevoConvenio: any
    AnnioInicioNuevoConvenio: any
    descripcion1: any
    descripcion2: any
    descripcion3: any    
    tiposReembolso: any
    postulantes: Usuario[]
    categorias: any = []
    subcategorias: any = []
    tiposDocumento: any = ['BONO', 'REEMBOLSO', 'BOLETA/FACTURA/VOUCHER']
    previsiones: any = []
    procesando: boolean = false
    cantidadArchivos: any = 1
    mostrarArchivosDentales: boolean = false
    mostrarCapacidadReembolso : boolean = false
    textos: any
    linkTexto: any

    reembolso: any = {
        afiliado: '', tipoReembolso: '', beneficiario: '', email: '', archivoTest: null,
        categoriaPrestacion: '', subCategoriaPrestacion: '', rutPrestador: '',
        archivos: [], fechaDocumento: '', tipoDocumento: '',
        nDocumento: '', nBoleta: '', montoCopago: '', montoReembolso: '', prevision: '', capacidad: ''
    }

    constructor(private router: Router, private productosService: ProductosService,
        private postulacionesSaludService: PostulacionesSaludService,
        private afiliacionService: AfiliacionService,
        private reembolsosService: ReembolsosService, private dialog: MatDialog,
        private tiposService: TiposService, private textosService: TextosService) { }

    ngOnInit(): void {
        this.loadData()

        if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
            this.traeTipos(3)

            this.traePostulantes(localStorage.getItem("rutUsuario"))
        }
    }

    loadData() {
        let vm = this
        /*
         vm.openAlertDialog('En estos momentos estamos realizando una mantención a la plataforma, pronto estaremos de vuelta. ', 'btn-danger')
         vm.router.navigate(['/index'])
         */
        vm.mostrarArchivosDentales=false
        this.productosService.obtieneProductos().then
            (
                productos => productos[2].parametros.map(parametro => {

                    if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                        vm.diasDiferencia = parametro.valor
                    }
                    if (parametro.descripcion == 'DIA_PRIMER_CONVENIO') {
                        vm.diaTerminoConvenio = parametro.valor
                    }
                    if (parametro.descripcion == 'MES_PRIMER_CONVENIO') {
                        vm.mesTerminoConvenio = parametro.valor
                    }
                    if (parametro.descripcion == 'ANNIO_PRIMER_CONVENIO') {
                        vm.AnnioTerminoConvenio = parametro.valor
                    }

                    if (parametro.descripcion == 'DIA_SEGUNDO_CONVENIO') {
                        vm.diaInicioNuevoConvenio = parametro.valor
                    }
                    if (parametro.descripcion == 'MES_SEGUNDO_CONVENIO') {
                        vm.mesInicioNuevoConvenio = parametro.valor
                    }
                    if (parametro.descripcion == 'ANNIO_SEGUNDO_CONVENIO') {
                        vm.AnnioInicioNuevoConvenio = parametro.valor
                    }
                    if (parametro.descripcion == 'DESCRIPCION1_ADJUNTO') {
                        vm.descripcion1 = parametro.valor
                    }
                    if (parametro.descripcion == 'DESCRIPCION2_ADJUNTO') {
                        vm.descripcion2 = parametro.valor
                    }
                    if (parametro.descripcion == 'DESCRIPCION3_ADJUNTO') {
                        vm.descripcion3 = parametro.valor
                    }

                })
            )
            .catch(error => console.log(error))

        this.reembolso.prevision = null

        this.reembolsosService.traePrevisionesDisponibles().then
            (
                (prestaciones) => {
                    vm.previsiones = prestaciones
                }
            )
    this.textosService.obtieneTextos()
    .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "REEMBOLSO")?.valor;             
    })
    .catch(error => {
        console.error('Error al obtener los textos:', error);
    });
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }





    ingresaAfiliado() {
        if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
            this.validarEstado(this.reembolso.afiliado.split('.').join('').split('-')[0])
        }
        this.reembolso.tipoReembolso = '', this.reembolso.beneficiario = '', this.tiposReembolso = []
        this.reembolso.archivos = [], this.postulantes = [], this.reembolso.archivoTest = null

        if (Rut(this.reembolso.afiliado)) {
            let rut = this.reembolso.afiliado.split('.').join('').split('-')[0]

            this.traeTipos(3)

            this.traePostulantes(rut)
        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
    }

    validarEstado(rutAfiliado){
        this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
        ( 
            (response: any) => {
                if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                    || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                        || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                            console.log(response.estadoAfiliado)
                    this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                    this.router.navigate(['/index'])                 
                }
            }
        )
        .catch
        (
            error => {
            console.log('error :',error);
            }
        ) 
    }

    seleccionaTipoReembolso() {
        let vm = this

        vm.categorias = []
        vm.reembolso.categoriaPrestacion = null
       
        if(this.reembolso.tipoReembolso!=8){
            vm.mostrarCapacidadReembolso=false
        }
        this.reembolsosService.traeCategorias(this.reembolso.tipoReembolso).then
            (
                response => {
                    console.log(response)
                    vm.categorias = response

                    vm.subcategorias = []
                    vm.reembolso.subCategoriaPrestacion = null
                }
            )
            .catch(error => console.log(error))
    }

    seleccionaCategoria() {
        let vm = this

        vm.subcategorias = []
        vm.reembolso.subCategoriaPrestacion = null  
        this.reembolsosService.traeSubCategorias(this.reembolso.categoriaPrestacion).then
            (
                subcategorias => {
                    console.log(subcategorias)

                    vm.subcategorias = subcategorias
                }
            )
            .catch(error => console.log(error))
          
        if(this.reembolso.categoriaPrestacion==12){
           vm.mostrarCapacidadReembolso=true      
           vm.mostrarArchivosDentales=true
        }else{
           vm.mostrarCapacidadReembolso=false
           vm.mostrarArchivosDentales=false
        }
       
        console.log('mostrarArchivosDentales:',vm.mostrarArchivosDentales)
    }


    logicaOdontologica() {
        let vm = this
        vm.mostrarArchivosDentales=true
        vm.subcategorias = []
        vm.reembolso.subCategoriaPrestacion = null
    }


    logicaCapacidadDescuento(event: any) {
       let vm = this
       let subcategoria = this.subcategorias[this.reembolso.subCategoriaPrestacion]
       let subCategoriaPrestacion=vm.reembolso.subCategoriaPrestacion

        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        Swal.showLoading();
        let usuarioSeleccionado = this.postulantes[this.reembolso.beneficiario]
        let usuarioTitular = usuarioSeleccionado
        this.postulantes.forEach(postulante => {
            if (postulante.parentesco == 'TITULAR') {
                usuarioTitular = postulante
            }

        })
        let usuarioId: any, cargaId: any, titular: any;
        if(!usuarioSeleccionado){
            this.openAlertDialog('Debe seleccionar un usuario.', 'btn-dark')
            this.procesando = false
            Swal.close();
            return
        }

        if (usuarioSeleccionado.parentesco == 'TITULAR') {
            titular = true
            usuarioId = usuarioSeleccionado.id
        }
        else {
            titular = false
            cargaId = usuarioSeleccionado.id
        }

        this.reembolsosService.retornarCapacidadDescuento(usuarioId, cargaId,titular,subcategoria.id).then
            (
                response => {
                    vm.reembolso.capacidad = response
                    Swal.close();
                }
            )
            .catch(error => console.log(error))
    }

   
    traeTipos(producto: any) {
        let vm = this

        this.tiposService.traeTipos(producto).then
            (
                (tipos: Tipos[]) => {
                    if (tipos.length > 0) { vm.tiposReembolso = tipos; }

                    else {
                        vm.openAlertDialog('El período de postulación se encuentra cerrado.', 'btn-dark')

                        this.router.navigate(['/index'])
                    }
                }
            )
            .catch(error => console.log('Se Cae el Tipo ', error))
    }

    traePostulantes(rut: any) {
        console.log(rut)
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let vm = this

        this.reembolsosService.traePostulantes(rut).then
            (
                (usuario: Usuario) => {
                    vm.reembolso.email = usuario.email
                    vm.nombreUsuario = usuario.nombres + ' ' + usuario.apellidoPaterno

                    let usuariosPostulantes: Array<Usuario> = []

                    usuariosPostulantes.push({
                        id: usuario.id, nombres: usuario.nombres,
                        apellidoPaterno: usuario.apellidoPaterno, apellidoMaterno: usuario.apellidoMaterno,
                        fechaNacimiento: ageCalculator(usuario.fechaNacimiento), sexo: usuario.sexo, rut: usuario.rut,
                        dv: usuario.dv, parentesco: 'TITULAR', fechaAfiliacion: usuario.fechaAfiliacion
                    })

                    usuario.carga ? usuario.carga.forEach(carga => {
                        carga.fechaNacimiento = ageCalculator(carga.fechaNacimiento)
                        carga.fechaAfiliacion = carga.fechaCreacion

                        usuariosPostulantes.push(carga)
                    }) : null;
                    Swal.close();
                    vm.postulantes = usuariosPostulantes
                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-dark')
            })
    }

    seleccionaArchivo(event: any, numero: number) {
        if (event.target.files.length > 0) {
            let vm = this
            let reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.reembolso.archivos[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }

                console.log(vm.reembolso.archivos)
            }
        }
    }

    sumaArchivo(dental: boolean) {
     
        if(dental && this.cantidadArchivos==1)
            this.cantidadArchivos=this.cantidadArchivos +2   
        if (this.cantidadArchivos <= 5) {

            this.cantidadArchivos = this.cantidadArchivos + 1
        }
    }

    restaArchivo() {

        this.cantidadArchivos = this.cantidadArchivos - 1;
        this.reembolso.archivos.splice(this.cantidadArchivos, 1);
    }

    solicitar(form: NgForm) {
        this.procesando = true;
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        Swal.showLoading();
        let usuarioSeleccionado = this.postulantes[this.reembolso.beneficiario]
        let usuarioTitular = usuarioSeleccionado
        this.postulantes.forEach(postulante => {
            if (postulante.parentesco == 'TITULAR') {
                usuarioTitular = postulante
            }

        })
        let usuarioId: any, cargaId: any, titular: any;
        let diaMesConvenio = "05"
        let anioConvenio = "2021"
        if (usuarioSeleccionado.parentesco == 'TITULAR') {
            titular = true
            usuarioId = usuarioSeleccionado.id
        }
        else {
            titular = false
            cargaId = usuarioSeleccionado.id
        }

        if (!Rut(this.reembolso.rutPrestador)) {
            this.openAlertDialog('El RUT del Prestador es incorrecto. Favor revisar.', 'btn-dark')
            this.procesando = false
            Swal.close();
            return
        }

        let fechaIngresada = new Date(this.reembolso.fechaDocumento + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia)

        if (fechaIngresada < fechaMinima || fechaIngresada > new Date()) {
            this.openAlertDialog('La Fecha del Documento supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
            this.procesando = false
            Swal.close();
            return
        }

        let sizeArchivos = 0;
  
       
        for (let i = 0; i < this.cantidadArchivos; i++) {
            sizeArchivos += this.reembolso.archivos[i].size;
            if (sizeArchivos > 25000000) {
                this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-dark')
                Swal.close();
                this.procesando = false
                return;
            }

            if (!sizeArchivos && sizeArchivos < 10) {
                this.openAlertDialog('Los archivos no deben venir vacios o casi vacios', 'btn-dark')
                Swal.close();
                this.procesando = false
                return;
            }

            if (this.reembolso.archivos[i].extension != "application/pdf" && this.reembolso.archivos[i].extension != "image/jpeg" &&
                this.reembolso.archivos[i].extension != "image/jpg" && this.reembolso.archivos[i].extension != "image/png") {
                this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
                this.procesando = false
                Swal.close();
                return false
            }
        }

        let subcategoria = this.subcategorias[this.reembolso.subCategoriaPrestacion]

        if (titular && subcategoria.id == 15) {
            this.openAlertDialog('Usted seleccionó al afiliado por lo que no puede seleccionar un beneficio de carga.', 'btn-dark')
            this.procesando = false
            Swal.close();
            return
        }
        else if (!titular && subcategoria.id == 14) {
            this.openAlertDialog('Usted seleccionó una carga por lo que no puede seleccionar un beneficio de afiliado.', 'btn-dark')
            this.procesando = false
            Swal.close();
            return
        }


        let fechaInicio = new Date(usuarioTitular.fechaAfiliacion.split('-')[2] + '-' +
            usuarioTitular.fechaAfiliacion.split('-')[1] + '-' +
            usuarioTitular.fechaAfiliacion.split('-')[0]).getTime();
        let fechaFin = new Date(Date.now()).getTime();

        let diasAfiliado = Math.round((fechaFin - fechaInicio) / (1000 * 60 * 60 * 24))

        if (subcategoria.carencia > diasAfiliado) {
            this.openAlertDialog('El afiliado seleccionado no cumple con la carencia para postular a esta SubCategoría.', 'btn-dark')
            this.procesando = false
            Swal.close();
            return
        }

        //VALIDACION MONTOS
        if (this.reembolso.tipoDocumento == 'BONO') {
            this.reembolso.montoReembolso = this.reembolso.montoCopago * subcategoria.porcentajeBono
        }
        else if (this.reembolso.tipoDocumento == 'REEMBOLSO') {
            this.reembolso.montoReembolso = this.reembolso.montoCopago * subcategoria.porcentajeReembolso
        }
        else { this.reembolso.montoReembolso = this.reembolso.montoCopago * subcategoria.porcentajeBoleta }

        if (this.reembolso.montoReembolso > subcategoria.topeEvento) { this.reembolso.montoReembolso = subcategoria.topeEvento }

        let vm = this
        let categoriaReembolso = this.reembolso.tipoReembolso;

        vm.reembolsosService.traeMontoDisponibleSubCategoria(usuarioSeleccionado.id, titular, subcategoria.id, 0).then
            (
                montoDisponible => {
                    console.log(montoDisponible)

                    if (montoDisponible == 0) {
                        Swal.close();
                        vm.openAlertDialog('Usted ya utilizó el cupo anual que tiene asignado para este tipo de reembolso por lo que no puede ingresar solicitud.', 'btn-danger')
                        vm.procesando = false

                        return
                    }
                    if (vm.reembolso.montoReembolso > montoDisponible) { vm.reembolso.montoReembolso = montoDisponible }
                    if (vm.reembolso.montoReembolso < 0) { vm.reembolso.montoReembolso = 0 }

                    let envioACompania = 0;

                    var fechaDocumento = new Date(vm.reembolso.fechaDocumento.split('-')[0], vm.reembolso.fechaDocumento.split('-')[1], vm.reembolso.fechaDocumento.split('-')[2]);
                    var fechaLimite = new Date(vm.AnnioTerminoConvenio, vm.mesTerminoConvenio, vm.diaTerminoConvenio);
                    var fechaNuevoConvenio = new Date(vm.diaInicioNuevoConvenio, vm.mesInicioNuevoConvenio, vm.AnnioInicioNuevoConvenio);


                    if (fechaDocumento <= fechaLimite) {
                        console.log("fechaLimite:", fechaLimite);
                        console.log("ANTES FECHA LIMITE");
                        envioACompania = 0;
                    } else {
                        console.log("fechaNuevoConvenio:", fechaNuevoConvenio);
                        console.log("DESPUES FECHA LIMITE");
                        envioACompania = 2;
                    }

                    vm.reembolsosService.ingresaReembolso(vm.reembolso, usuarioId, cargaId, vm.nombreUsuario, subcategoria, idUsuarioSesion).then
                        (
                            (response: any) => {
                                if (vm.reembolso != null && categoriaReembolso != 8 && envioACompania > 0) {
                                    this.resetearArchivos();
                                    let idPostulacion = response.id;
                                    if (envioACompania == 1) {
                                        vm.postulacionesSaludService.envioCompania(idPostulacion).then(

                                            () => {
                                                vm.postulacionesSaludService.cambiarEstadoPostulacion(idPostulacion, "ENVIADO A COMPANIA", idUsuarioSesion).then(
                                                    () => {

                                                        Swal.close();
                                                        vm.openAlertDialog('Solicitud ingresada exitosamente y se ha enviado a compañía BCI.', 'btn-success')
                                                        vm.reembolso.tipoReembolso = '', vm.reembolso.archivos = [], vm.procesando = false

                                                        form.reset()

                                                    }
                                                ).catch(
                                                    error => {
                                                        console.log(error)
                                                        Swal.close();

                                                        vm.openAlertDialog('Ha ocurrido un error al cambiar el estado de la postulación, pero su reembolso fue creado y enviado a la compañía.', 'btn-danger')
                                                        vm.reembolso.tipoReembolso = '', vm.reembolso.archivos = [], vm.procesando = false
                                                        form.reset()
                                                    }
                                                )
                                            })
                                            .catch(error => {
                                                console.log(error)
                                                Swal.close();

                                                vm.openAlertDialog('Su solicitud no se pudo enviar a la compañia, pero su reembolso fue creado en el sistema.', 'btn-danger')
                                                vm.reembolso.tipoReembolso = '', vm.reembolso.archivos = [], vm.procesando = false

                                                form.reset()
                                            })
                                    }else if(envioACompania >1){
                                        vm.postulacionesSaludService.envioCompaniaVidaCamara(idPostulacion).then(
                                            () => {
                                                vm.postulacionesSaludService.cambiarEstadoPostulacion(idPostulacion, "ENVIADO A COMPANIA", idUsuarioSesion).then(
                                                    () => {                                                    
                                                        Swal.close();
                                                        this.resetearArchivos();
                                                        vm.openAlertDialog('Solicitud ingresada exitosamente y se ha enviado a compañía Vida Camara', 'btn-success')
                                                        vm.reembolso.tipoReembolso = '', vm.reembolso.archivos = [], vm.procesando = false

                                                        form.reset()

                                                    }
                                                ).catch(
                                                    error => {
                                                        console.log(error)
                                                        Swal.close();

                                                        vm.openAlertDialog('Ha ocurrido un error al cambiar el estado de la postulación, pero su reembolso fue creado y enviado a la compañía.', 'btn-danger')
                                                        vm.reembolso.tipoReembolso = '', vm.reembolso.archivos = [], vm.procesando = false
                                                        form.reset()
                                                    }
                                                )
                                            })
                                            .catch(error => {
                                                console.log(error)
                                                Swal.close();

                                                vm.openAlertDialog('Su solicitud no se pudo enviar a la compañia, pero su reembolso fue creado en el sistema.', 'btn-danger')
                                                vm.reembolso.tipoReembolso = '', vm.reembolso.archivos = [], vm.procesando = false

                                                form.reset()
                                            })

                                    }
                                } else {
                                    Swal.close();
                                    console.log('envioACompania:',envioACompania)
                                    this.resetearArchivos();
                                    vm.openAlertDialog('Solicitud ingresada exitosamente .', 'btn-success')
                                    vm.reembolso.tipoReembolso = '', vm.reembolso.archivos = [], vm.procesando = false

                                    form.reset()
                                }
                            }
                        )
                        .catch(errorFinal => {
                            vm.procesando = false
                            this.resetearArchivos();
                            if (errorFinal.error.message){
                                Swal.close();
                                vm.openAlertDialog(errorFinal.error.message, 'btn-danger')
                                return
                            }else if (errorFinal.status == 403) {
                                Swal.close();
                                vm.openAlertDialog('Usted ya ingresó una solicitud con el mismo N. Documento, Tipo de Documento, Rut de prestador y número de boleta .', 'btn-danger')
                                return
                            }
                            else {
                                Swal.close();
                                vm.openAlertDialog('Ha ocurrido un error al ingresar el Reembolso', 'btn-danger')
                            }
                        })
                }
            )
            .catch
            (
                error => {
                    console.log(error)
                    console.log("si hay error, hace nuevamente el ingreso y envío a compañía");
                    this.resetearArchivos();
                    if (error.status != 404) {
                        Swal.close();
                        vm.openAlertDialog('Usted ya utilizó el cupo anual que tiene asignado para este tipo de reembolso por lo que no puede ingresar solicitud.', 'btn-danger')
                        return
                    } else {
                        Swal.close();
                        vm.openAlertDialog('Ha ocurrido un error interno.', 'btn-danger')
                        return
                    }

                }
            )
    }

    resetearArchivos() {
        let vm = this
        vm.mostrarCapacidadReembolso=false
        vm.mostrarArchivosDentales=false
        this.cantidadArchivos = 1;
        this.reembolso.archivos.splice(1, 1);
    }

    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir() { this.router.navigate(['/index']) }
}
